import { H5, P } from '../../../AbstractElements';
import { ArticalsData } from '../../../Data/KnowledegesBase';
import React, { Fragment } from 'react';
import { Card, CardBody, Col } from 'reactstrap';

const Articals = () => {
  return (
    <Fragment>
      {ArticalsData.map((item) => {
        return (
          <Col xl="4" className={item.class2} key={item.id}>
            <Card className='bg-primary'>
              <CardBody>
                <div className='d-flex faq-widgets'>
                  <div className='flex-grow-1'>
                    <H5>{item.title}</H5>
                    <P>{item.para}</P>
                  </div>
                  {item.icon}
                </div>
              </CardBody>
            </Card>
          </Col>
        );
      })}
    </Fragment>
  );
};
export default Articals;
